<template>
  <div class="container" id="community-apply-tab-template">
    <ul class="divided-tabs tab-count--5 clearfix" role="tablist" id="buttons-tab">
      <li class="divided-tab active" role="presentation" id="step1" style="width: 25%;">
        <a class="divided-tab__link" href="#decsList1"
           aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab">
          커뮤니티 개요<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>

      <li class="divided-tab" role="presentation" id="step2" style="width: 25%;">
        <a class="divided-tab__link" href="#decsList2"
           aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab" >
          커뮤니티 정보<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>

      <li class="divided-tab" role="presentation" id="step3" style="width: 25%;">
        <a class="divided-tab__link" href="#decsList4"
           aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab" >
          커뮤니티 운영자<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>

      <li class="divided-tab" role="presentation" id="step4" style="width: 25%;">
        <a class="divided-tab__link" href="#decsList5"
           aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab" >
          커뮤니티 사업안내<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>

    </ul>
    <div class="divided-tabpanels tab-content">
      <div role="tabpanel" class="tab-pane active"
           id="decsList1">
        <div class="lg-label-form-group">
          <label class="lg-label">커뮤니티 개요</label>
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">커뮤니티 명</label>
            <input type="text" v-model.trim="name" class="input__text" ref="name" placeholder="최대 30자까지 입력가능합니다." maxlength="30" title="최대 30자까지 입력가능합니다.">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">소개글</label>
            <textarea v-model.trim="desc" class="input__textarea input__textarea--thin" ref="desc" placeholder="최대 200자까지 입력가능합니다." rows=2 maxlength="200" title="최대 200자까지 입력가능합니다."></textarea>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">대표이미지</label>
            <form name="formcommunityFile01" id="formcommunityFile01" method="post" enctype="multipart/form-data" action="/api/file-uploads">
              <input type="file" name="file" id="communityFile01"  ref="imgUrl" accept="image/gif, image/jpeg, image/png" v-on:change="imgUrlChange('communityFile01')"
                   class="inline-input__file" title="대표이미지 첨부파일 선택">
            </form>
            <p class="guide-text">277 * 208 px에 최적화 되어 있습니다.</p>
            <img v-if="imgUrl" :src="imgUrl" class="file-uploads-thumb" alt="업로드이미지">
            <img v-else class="file-uploads-thumb" alt="업로드이미지" src="/images/img/communityDefault.jpg">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">등록기관</label>
            <select class="input__select" v-model.trim="org" ref="org" title=" 선택">
              <option v-for="list in orgList" :value="list.code">{{list.name}}</option>
            </select>
          </div>


          <div class="inline-input-group clearfix">
            <label class="inline-input__label">회원수</label>
            <input type="number" v-model.trim="memberCount" ref="memberCount" class="input__text" placeholder="숫자로만 입력해주세요. 예) 10명 일경우 10" title="숫자로만 입력해주세요. 예) 10명 일경우 10">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">결성시기</label>
            <div class="f-gutter-10">
              <div class="f-gutter-10__li grid-2">
                <input type="number" v-model.trim="formationYear" class="input__text" placeholder="예) 1990년일 경우 1990" ref="formationYear" maxlength="4" title="예) 1990년일 경우 1990">
              </div>
              <div class="f-gutter-10__li grid-2">
                <input type="number" v-model.trim="formationMonth" class="input__text" placeholder="예) 1월일 경우 01" ref="formationMonth" maxlength="2" title="예) 1월일 경우 01">
              </div>
            </div>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">모임주기</label>
            <div class="f-gutter-10">
              <div class="f-gutter-10__li grid-6">
                <label class="checkbox-inline label__radio">
                  <input class="input__checkbox" v-model.trim="meetingChk" type="radio" value="fixed" ref="meetingChk" title="정기 선택"> 정기
                </label>
              </div>
              <div class="f-gutter-10__li grid-2">
                <input type="text" v-model.trim="meetingPeriod" class="input__text" placeholder="예) 주 1회" ref="meetingPeriod" maxlength="30" title="예) 주 1회">
              </div>
              <div class="f-gutter-10__li grid-5">
                <label class="checkbox-inline label__radio">
                  <input class="input__checkbox" v-model.trim="meetingChk" type="radio" value="non-fixed" ref="meetingChk" title="비정기 선택"> 비정기
                </label>
              </div>
            </div>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">주요 모임  <br/>또는 활동 장소</label>
            <select class="input__select" v-model.trim="meetingPlace" ref="meetingPlace" title=" 선택">
              <option v-for="list in address">{{list}}</option>
            </select>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">활동 주제</label>
            <label class="radio-inline label__radio" v-for="(list, idx) in subject">
              <input type="radio" v-model.trim="selectSubject" name="inlineRadioOptions" :id="`inlineRadio${idx}`" ref="selectSubject"
                     :value="list.name" title="활동 주제 선택"> {{list.name}}
            </label>
          </div>
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">※ 관리자가 커뮤니티 소식 컨텐츠를 수정할 수 있다는 것에 대해 동의 하십니까?</label>
          </div>
          <div class="inline-input-group clearfix">
            <div class="f-gutter-10__li grid-6">
              <label class="checkbox-inline label__radio">
                <input class="input__checkbox" v-model.trim="editagree" type="radio" value="Y" ref="editagree" title="예 선택"> 예
              </label>
            </div>
            <div class="f-gutter-10__li grid-5">
              <label class="checkbox-inline label__radio">
                <input class="input__checkbox" v-model.trim="editagree" type="radio" value="N" ref="editagree" title="아니요 선택"> 아니요
              </label>
            </div>            
          </div>
        </div>

        <div class="">
          <button type="button" @click="goStep2" class="form-submit__btn btn--blue-line">다음</button>
        </div>
      </div>

      <div role="tabpanel" class="tab-pane"
           id="decsList2">
        <div class="lg-label-form-group">
          <label class="lg-label">커뮤니티 한마디</label>

          <div class="result-group-with-btn clearfix">
            <div class="grid-3">
              <p class="progress__only-text">예) 총무 김무자</p>
            </div>
            <div class="grid-33">
              <p class="progress__only-text">예) 지치지 않는 열정의 프로펠러</p>
            </div>
          </div>

          <div class="input-group-with-btn clearfix">
            <div class="grid-3 p-r-20">
              <input type="text" v-model.trim="commentsWriter" class="input__text"  placeholder="최대 30자까지 입력가능합니다." ref="commentsWriter" title="최대 30자까지 입력가능합니다.">
            </div>
            <div class="grid-33">
              <input type="text" v-model.trim="commentsInput" class="input__text"  placeholder="최대 100자까지 입력가능합니다." ref="commentsInput" title="최대 100자까지 입력가능합니다.">
            </div>
            <button type="button" @click="addComments" class="input-btn btn--gray">추가</button>
          </div>

          <ul class="input-added-list" v-if="comments.length > 0">
            <li v-for="(comment, idx) in comments">
              <div class="result-group-with-btn clearfix">
                <div class="grid-3">
                  <p class="progress__only-text">{{comment.writer}}</p>
                </div>
                <div class="grid-33 border-l l-m-p-10">
                  <p class="progress__only-text">{{comment.comment}}</p>
                </div>
                <button type="button" @click="removeComments(idx)" class="input-btn btn--gray">삭제</button>
              </div>
            </li>
          </ul>
        </div>

        <div class="lg-label-form-group">
          <label class="lg-label">배너 등록</label>

          <div class="result-group-with-btn clearfix">
            <div class="grid-3">
              <p class="progress__only-text">예) 총무 김무자</p>
            </div>
            <div class="grid-3">
              <p class="progress__only-text">예) 꽃동네 봉사활동</p>
            </div>
            <div class="grid-3">
              <p class="progress__only-text">http://www.naver.com</p>
            </div>
          </div>

          <div class="input-group-with-btn clearfix">
            <div class="grid-3">
              <form name="formbannerImg" id="formbannerImg" method="post" enctype="multipart/form-data" action="/api/file-uploads">
                <input type="file" name="file" id="bannerImg" accept="image/gif, image/jpeg, image/png"  v-on:change="imgUrlChange('bannerImg')" class="inline-input__file" ref="bannerImg" title="bannerImg 첨부파일 선택">
              </form>
            </div>
            <div class="grid-3 p-r-20">
              <input type="text" v-model.trim="title" class="input__text" placeholder="최대 30자까지 입력가능합니다." ref="title" title="최대 30자까지 입력가능합니다.">
            </div>
            <div class="grid-3">
              <input type="url" v-model.trim="linkUrl" class="input__text" placeholder="예) http://www.naver.com / 최대 50자까지 입력가능합니다." ref="linkUrl" title="예) http://www.naver.com / 최대 50자까지 입력가능합니다.">
            </div>
            <button type="button" @click="addBanner" class="input-btn btn--gray">추가</button>
            <div class="helper-text xs-text">*확장자 jpg, jpeg, png, gif<br> 파일만 올려주세요.(2mb 이하)<br>1130*204px</div>
          </div>

          <ul class="input-added-list" v-if="banners.length > 0">
            <li v-for="(banner, idx) in banners">
              <div class="result-group-with-btn clearfix">
                <div class="grid-3 inner-img">
                  <img v-if="banner.imageUrl" :src="banner.imageUrl" class="file-uploads-thumb" alt="업로드이미지">
                </div>
                <div class="grid-3 border-l l-m-p-10">
                  <p class="progress__only-text">{{banner.title}}</p>
                </div>
                <div class="grid-3">
                  <p class="progress__only-text">{{banner.linkUrl}}</p>
                </div>
                <button type="button" @click="removeBanner(idx)" class="input-btn btn--gray">삭제</button>
              </div>
            </li>

          </ul>
        </div>

        <div class="lg-label-form-group">
          <label class="lg-label">커뮤니티 연락처</label>
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">이메일</label>
            <input type="email" v-model.trim="email" class="input__text" placeholder="example@example.com" ref="email" title="example@example.com">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">홈페이지 url</label>
            <input type="url" v-model.trim="homepageUrl" class="input__text" placeholder="http://daum.net" ref="homepageUrl" title="http://daum.net">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">sns url</label>
            <input type="url" v-model.trim="snsUrl" class="input__text" placeholder="http://facebook.com" ref="snsUrl" title="http://facebook.com">
          </div>
        </div>

        <div class="">
          <button type="button" @click="prevStep('1')" class="form-submit__btn btn--blue-line">이전</button>
          <button type="button" @click="goStep3" class="form-submit__btn btn--blue-line">다음</button>
        </div>
      </div>

      <div role="tabpanel" class="tab-pane "
           id="decsList3">
        <template v-if="operators.length > 0 && !isModify2">
          <div class="text-right">
            <button type="button" @click="modifyOperator()" class="community-add-btn btn--gray">수정
            </button>
          </div>
          <div class="lg-label-form-group" v-for="(operator, idx) in operators">
            <div class="form-box-gray">
              <table><caption>커뮤니티 회원 상세 정보</caption>
                <tr>
                  <td width="45%">
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">이름</label>
                      <p class="progress__only-text">{{member.name}}</p>
                    </div>
                  </td>
                  <td width="10%">
                  </td>
                  <td width="45%">
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">생년월일</label>
                      <p class="progress__only-text">{{member.birthdate}}</p>
                    </div>
                  </td>
                <tr>
                  <td>
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">연락처</label>
                      <p class="progress__only-text">{{member.phone1}}-{{member.phone2}}-{{member.phone3}}</p>
                    </div>
                  </td>
                  <td width="10%">
                  </td>
                  <td>  
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">이메일</label>
                      <p class="progress__only-text">{{member.email}}</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan=2>
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">주소</label>
                      <p class="progress__only-text">{{member.addr1}} {{member.addr2}}</p>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <template v-if="operators.length > 0 && isModify2">
          <div class="text-right">
            <button type="button" @click="updateOperator()" class="community-add-btn btn--gray">저장
            </button>
          </div>
          <div class="lg-label-form-group" v-for="(operator, idx) in operators">
            <div class="form-box-gray">
              <table><caption>커뮤니티 회원 목록</caption>
                <tr>
                  <td width="45%">
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">이름</label>
                      <input type="text" v-model.trim="member.name" class="input__text" placeholder="" ref="member.name" readonly title=" 입력">
                    </div>
                  </td>
                  <td width="10%">
                  </td>
                  <td width="45%">
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">생년월일</label>
                      <input type="text" v-model.trim="member.birthdate" class="input__text" placeholder="" ref="member.birthdate" readonly title=" 입력">
                    </div>
                  </td>
                <tr>
                  <td>
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">연락처</label>
                      <table>
                        <tr>
                          <td width="30%">
                            <input type="number" maxlength="3" oninput="this.value=this.value.slice(0,this.maxLength)" v-model.trim="member.phone1" class="input__text" placeholder="" ref="member.phone1" title=" 입력">
                          </td>
                          <td width="5%"></td>
                          <td width="30%">
                            <input type="number" maxlength="4" oninput="this.value=this.value.slice(0,this.maxLength)" v-model.trim="member.phone2" class="input__text" placeholder="" ref="member.phone2" title=" 입력">
                          </td>
                          <td width="5%"></td>
                          <td width="30%">  
                            <input type="number" maxlength="4" oninput="this.value=this.value.slice(0,this.maxLength)" v-model.trim="member.phone3" class="input__text" placeholder="" ref="member.phone3" title=" 입력">
                          </td>
                        </tr>
                    </div>
                  </td>
                  <td width="10%">
                  </td>
                  <td>  
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">이메일</label>
                      <input type="text" v-model.trim="member.email" class="input__text" placeholder="" ref="member.email" title=" 입력">
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan=3>
                    <div class="inline-readonly-group clearfix">
                      <label class="inline-input__label">주소</label>
                      <input type="text" v-model.trim="member.addr1" class="input__text" placeholder="" ref="member.addr1" title=" 입력">
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan=3>
                    <div class="inline-readonly-group clearfix">
                      <input type="text" v-model.trim="member.addr2" class="input__text" placeholder="" ref="member.addr2" title=" 입력">
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <div class="">
          <button type="button" @click="prevStep('2')" class="form-submit__btn btn--blue-line">이전</button>
          <button type="button" @click="goStep4" class="form-submit__btn btn--blue-line">다음</button>
        </div>
      </div>
      <div role="tabpanel" class="tab-pane "
           id="decsList4">
        <div class="lg-label-form-group">
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">내용</label>
            <p class="progress__only-text">50+세대가 동료와 함께 기획한 프로젝트를 실행하도록 활동비 등을 지원합니다. 자신의 경험과 재능을 동료와 나누세요. 서부캠퍼스 교육과정 수강을 계기로 모였거나 관심사를 공유하는 50+세대 커뮤니티라면 신청 가능합니다.</p>
            <br>
            <label class="inline-input__label">대상</label>
            <p class="progress__only-text">•  캠퍼스 프로그램 참여 후 동기들과 활동을 이어가기 위해 결성한 커뮤니티</p>
            <p class="progress__only-text">•  50+세대 생애 설계, 신문화 확산 관련 활동을 하고 있거나 계획 중인 커뮤니티</p>
            <p class="progress__only-text">•  지역사회, 세대통합 등 공익을 위한 활동을 하고 있거나 계획 중인 커뮤니티</p>
            <br>
            <p class="progress__only-text">01. 최소 3명 이상의 50+세대로 구성된 모임이어야 합니다.</p>
            <p class="progress__only-text">02. 대표자는 만 50 ~ 64세의 서울시민이거나 사업장 주소가 서울시여야 합니다.</p>
            <p class="progress__only-text">03. 국적 등 기타 자격 관련 사항은 별도 문의 바랍니다.</p>
            <br>
            <label class="inline-input__label">지원활동</label>
            <p class="progress__only-text">50+세대의 일, 학습, 문화생활, 사회공헌 관련 활동</p>
            <div class="progress-etc-box">
              <h5 class="progress-etc-box__title">예시)</h5>
              <ul class="progress-etc-box__ul">
                <li>· 창업·창직, 경력개발, 사회적경제, 공익단체설립 등 일 관련 연구 및 실행 활동</li>
                <li>· 신기술, 사회이론, 인문학, 역사, 기타 주제 강의, 세미나, 포럼 등 학습 활동</li>
                <li>· 예술, 문학, 음악, 미술, 영상 등의 감상 및 창작 관련 문화 활동</li>
                <li>· 지역사회, 세대통합, 취약계층, 공익 등을 위한 사회공헌 활동</li>
              </ul>
            </div>
            <br>
            <label class="inline-input__label">신청방법</label>
            <p class="progress__only-text">•  홈페이지 접수</p>
            <p class="progress__only-text">•  제출 서류 : 참가신청서 (홈페이지에서 양식 다운로드 후 작성)</p>
            <br>
            <label class="inline-input__label">선정절차</label>
            <img src="/images/applystep.png" alt="단계설명이미지">
            <br>
            <label class="inline-input__label">선정기준</label>
            <p class="progress__only-text">•  활동 계획 : 사업 취지와의 적합성, 활동 목적의 현실성, 계획의 구체성</p>
            <p class="progress__only-text">•  예산 편성 : 예산안의 적합성과 구체성, 활동비 지출 관리 역량</p>
            <br>
            <p class="progress__only-text">01. 캠퍼스 프로그램 참여 후 관련 활동을 계획하는 커뮤니티를 우대합니다.</p>
            <p class="progress__only-text">02. 개방적인 성격의 커뮤니티로 캠퍼스에서 동료를 찾는 커뮤니티를 우대합니다.</p>
            <p class="progress__only-text">03. 상담 과정에서 대표와 구성원의 활동 의지, 의사소통 정도를 중점적으로 확인합니다.</p>
          </div>
          <div class="text-center" style="margin-bottom: 30px;">
            <label class="checkbox-inline progress-label__agree-ckeck">
              <input class="input__checkbox" type="checkbox" id="privacyAgree" v-model.trim="isPrivacyAgree"
                   value="privacyAgree" title="개인정보 수집 이용 동의 확인 선택"> 확인하였습니다.
            </label>
          </div>
        </div>
        <div class="">
          <button type="button" @click="prevStep('3')" class="form-submit__btn btn--blue-line">이전 </button>
          <button type="button" @click="communityApply" class="form-submit__btn btn--blue-line">신청하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';
  import moment from 'moment';

  export default {
    name: 'community-apply-tab-template',
    props: ['subject', 'orgList', 'member'],
    data() {
      return {
        address: [
          '강남구',
          '강동구',
          '강서구',
          '강북구',
          '광진구',
          '관악구',
          '구로구',
          '금천구',
          '노원구',
          '도봉구',
          '동대문구',
          '동작구',
          '마포구',
          '서대문구',
          '서초구',
          '성동구',
          '성북구',
          '송파구',
          '양천구',
          '영등포구',
          '용산구',
          '은평구',
          '종로구',
          '중구',
          '중랑구',
        ],
        url: '/api/communities',
        name: '',
        desc: '',
        imgUrl: '',
        memberCount: '',
        formationDate: '',
        formationYear: '',
        formationMonth: '',
        meetingChk: '',
        meetingPeriod: '',
        meetingPlace: '',
        selectSubject: '',
        email: '',
        homepageUrl: '',
        snsUrl: '',
        org: '',
        representation: {},
        manager: {},
        comments: [],
        banners: [],
        members: [],
        operators: [],
        likeOrgs: [],
        occuPation: [],
        isModify: false,
        isModify2: false,
        communityPlus: false,
        applicant: {},
        status: '',
        commentsWriter: '',
        commentsInput: '',
        linkUrl: '',
        title: '',
        bannerImg: '',
        isPrivacyAgree: false,
        agreeStep2: false,
        agreeStep4: false,
        editagree: '',
        communityMember: {},
        operator: {},
        reason: ' ',
      };
    },
    methods: {
      imgUrlChange(id) {
        const that = this;
        const formid = `#form${id}`;
        $(formid).ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.responseJSON.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              if (id === 'communityFile01') that.imgUrl = response.filename;
              else if (id === 'bannerImg') that.bannerImg = response.filename;
            } else {
              alert(statusText);
            }
          },
        });
      },
      addComments() {
        if (!this.commentsWriter) {
          alert('이름을 입력해 주세요.');
          this.$refs.commentsWriter.focus();
        } else if (this.commentsWriter.length > 30) {
          alert('이름은 30자까지 입력가능합니다.');
          this.$refs.commentsWriter.focus();
        } else if (!this.commentsInput) {
          alert('한마디를 입력해 주세요.');
          this.$refs.commentsInput.focus();
        } else if (this.commentsInput.length > 100) {
          alert('한마디는 100까지 입력가능합니다.');
          this.$refs.commentsInput.focus();
        } else if (this.commentsWriter && this.commentsInput) {
          this.comments.push({ writer: this.commentsWriter, comment: this.commentsInput });
          this.commentsWriter = '';
          this.commentsInput = '';
        }
      },
      removeComments(idx) {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          this.comments.splice(idx, 1);
        }
      },
      addBanner() {
        if (!this.bannerImg) {
          alert('배너 이미지를 추가해 주세요.');
          this.$refs.bannerImg.focus();
        } else if (!this.title) {
          alert('배너 타이틀을 입력해 주세요.');
          this.$refs.title.focus();
        } else if (this.title > 30) {
          alert('배너 타이틀은 최대 30자까지 입력가능합니다.');
          this.$refs.title.focus();
        } else if (!this.linkUrl) {
          alert('배너 링크를 입력해 주세요.');
          this.$refs.linkUrl.focus();
        } else if (this.linkUrl > 50) {
          alert('배너 링크는 최대 50자까지 입력가능합니다.');
          this.$refs.linkUrl.focus();
        } else if (this.title && this.bannerImg && this.linkUrl) {
          this.banners.push({
            title: this.title,
            imageUrl: this.bannerImg,
            linkUrl: this.linkUrl,
          });
          document.getElementById('bannerImg').value = '';
          this.title = '';
          this.bannerImg = '';
          this.linkUrl = '';
        }
      },
      removeBanner(idx) {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          this.banners.splice(idx, 1);
        }
      },
      addMember() {
        if (this.communityMember.phone2 > 9999 || this.communityMember.phone3 > 9999
          || this.communityMember.phone2.length < 3 || this.communityMember.phone3.length < 4) {
          alert('연락처를 바르게 입력해 주세요.');
          return;
        }
        if (!this.communityMember.name) {
          alert('구성원 이름을 입력해주세요.');
          this.$refs.communityMemberName.focus();
        } else if (this.communityMember.name.length > 10) {
          alert('구성원 이름은 10자 이하로 입력해주세요.');
          this.$refs.communityMemberBirthDate.focus();
        } else if (!this.communityMember.phone1) {
          alert('구성원 연락처를 입력해 주세요.');
          this.$refs.communityMemberPhone1.focus();
        } else if (this.communityMember.phone1 < 0) {
          alert('구성원 연락처를 확인해 주세요.');
          this.$refs.communityMemberPhone1.focus();
        } else if (!this.communityMember.phone2) {
          alert('구성원 연락처를 입력해 주세요.');
          this.$refs.communityMemberPhone2.focus();
        } else if (!this.communityMember.phone3) {
          alert('구성원 연락처를 입력해 주세요.');
          this.$refs.communityMemberPhone3.focus();
        } else if (this.communityMember.name
          && this.communityMember.phone1
          && this.communityMember.phone2
          && this.communityMember.phone3) {
          this.members.push({
            name: this.communityMember.name,
            phone1: this.communityMember.phone1,
            phone2: this.communityMember.phone2,
            phone3: this.communityMember.phone3,
          });
          this.communityMember.name = '';
          this.communityMember.birthdate = '';
          this.communityMember.phone1 = '010';
          this.communityMember.phone2 = '';
          this.communityMember.phone3 = '';
          /* this.communityMember.email = ''; */
          /* this.communityMember.addrCity = ''; */
          /* this.communityMember.addrGu = ''; */
          this.communityMember.role = '';
        }
        /* alert(this.members.length); */
        this.isModify = true;
      },
      removeMember(idx) {
        const result = window.confirm('구성원정보를 삭제하시겠습니까?');
        if (result) {
          this.members.splice(idx, 1);
        }
      },
      modifyMember() {
        this.isModify = true;
      },
      addOperator() {
        if (!this.operator.name) {
          alert('운영자 이름을 입력해 주세요.');
          this.$refs.operatorName.focus();
        } else if (this.operator.name.length > 30) {
          alert('운영자 이름은 30자까지 입력가능합니다.');
          this.$refs.operatorName.focus();
        } else if (!this.operator.loginid) {
          alert('운영자 아이디를 입력해 주세요.');
          this.$refs.operatorLoginid.focus();
        } else if (this.operator.loginid > 30) {
          alert('운영자 아이디는 30자까지 입력가능합니다.');
          this.$refs.operatorLoginid.focus();
        } else if (!this.operator.phone) {
          alert('운영자 연락처를 입력해 주세요.');
          this.$refs.operatorPhone.focus();
        } else if (this.operator.name && this.operator.loginid && this.operator.phone) {
          this.operators.push({
            name: this.operator.name,
            loginid: this.operator.loginid,
            phone: this.operator.phone,
          });
          this.operator.name = '';
          this.operator.loginid = '';
          this.operator.phone = '';
        }
      },
      modifyOperator() {
        const result = window.confirm('수정하시겠습니까?');
        if (result) {
          this.isModify2 = true;
          /* this.operators.splice(idx, 1); */
        }
      },
      updateOperator() {
        const result = window.confirm('저장하시겠습니까?');
        if (result) {
          if (!this.member.email || !this.member.email) {
            alert('이메일을 입력해 주세요.');
          } else if (!this.member.phone1 || !this.member.phone2 || !this.member.phone3) {
            alert('연락처를 입력해 주세요.');
          } else {
            const Params = {
              email: this.member.email,
              birthdate: this.member.birthdate,
              phone1: this.member.phone1,
              phone2: this.member.phone2,
              phone3: this.member.phone3,
              addr1: this.member.addr1,
              addr2: this.member.addr2,
              zipcode: this.member.zipcode,
              gender: this.member.gender,
              applyPath: this.member.applyPath,
              joinPurpose: this.member.joinPurpose,
              likeOrgs: ['fpp', 'org', 'swc', 'scc', 'ssc', 'nwc', 'dsc', 'djc', 'ydp', 'sec', 'sdm', 'sbc'],
              photoUrl: this.member.photoUrl,
              occuPation: this.occuPationStr,
            };
            Axios.put('/api/members/info', Params).then(() => {
              alert('저장되었습니다.');
              /* location.reload(); */
            }).catch((e) => {
              alert(e.response.data.msg);
            });
          }
        }
      },
      communityApply() {
        if (!this.isPrivacyAgree) {
          alert('확인하였습니다를 체크하셔야 신청이 가능합니다.');
        } else {
          const Params = {
            name: this.name,
            desc: this.desc,
            imgUrl: this.imgUrl,
            memberCount: this.memberCount,
            formationDate: `${this.formationYear.slice(2)}${this.formationMonth}`,
            meetingPeriod: this.meetingPeriod,
            meetingPlace: this.meetingPlace,
            subject: this.selectSubject,
            email: this.email,
            homepageUrl: this.homepageUrl,
            snsUrl: this.snsUrl,
            org: this.org,
            comments: this.comments,
            banners: this.banners,
            members: this.members,
            operators: this.operators,
            editagree: this.editagree,
            reason: this.reason,
          };
          Axios.post(this.url, Params).then(() => {
            alert('신청되었습니다.');
            location.href = '/mypage-community.do';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      goStep2() {
        if (this.meetingChk === 'non-fixed') this.meetingPeriod = '비정기';

        if (!this.name) {
          alert('커뮤니티명을 입력해 주세요.');
          this.$refs.name.focus();
        } else if (this.name.length > 30) {
          alert('커뮤니티명은 30자 이하로 입력해 주세요.');
          this.$refs.name.focus();
        } else if (!this.desc) {
          alert('커뮤니티 설명을 입력해 주세요.');
          this.$refs.desc.focus();
        } else if (this.desc.length > 200) {
          alert('커뮤니티 설명을 200자 이하로 입력해 주세요.');
          this.$refs.desc.focus();
        } else if (!this.org) {
          alert('등록 기관을 선택해 주세요.');
          this.$refs.org.focus();
        } else if (!this.memberCount) {
          alert('회원수를 입력해 주세요. 예) 10명 일경우 10');
          this.$refs.memberCount.focus();
        } else if (/[^0-9]/g.test(this.memberCount) || this.memberCount < 0) {
          alert('회원수를 확인해 주세요. 예) 10명 일경우 10');
          this.$refs.memberCount.focus();
        } else if (!this.formationYear) {
          alert('결성시기 년도를 입력해 주세요. 예) 1990년일경우 1990');
          this.$refs.formationYear.focus();
        } else if (/[^0-9]/g.test(this.formationYear) || this.formationYear.length !== 4) {
          alert('결성시기 년도를 확인해 주세요. 예) 1990년일경우 1990');
          this.$refs.formationYear.focus();
        } else if (!this.formationMonth) {
          alert('결성시기 월을 입력해 주세요. 예) 1월일 경우 01');
          this.$refs.formationMonth.focus();
        } else if (/[^0-9]/g.test(this.formationMonth) || this.formationMonth < 0 || this.formationMonth.length !== 2) {
          alert('결성시기 월을 확인해 주세요. 예) 1월일 경우 01');
          this.$refs.formationMonth.focus();
        } else if (!this.meetingChk) {
          alert('모임주기를 입력해 주세요.');
          this.$refs.meetingChk.focus();
        } else if (this.meetingChk !== 'non-fixed' && !this.meetingPeriod) {
          alert('모임주기를 입력해 주세요.');
          this.$refs.meetingPeriod.focus();
        } else if (!this.meetingPlace) {
          alert('주요 모임 또는 활동 장소를 선택해 주세요.');
          this.$refs.meetingPlace.focus();
        } else if (!this.selectSubject) {
          alert('활동 주제를 선택해 주세요.');
        } else if ((this.formationYear !== '' &&
          this.formationYear.length !== 4) ||
          (parseInt(this.formationYear, 10) > parseInt(moment().format('YYYY'), 10))) {
          alert('년도 입력을 다시 확인해주세요.(4자리로 입력해 주세요.)');
        } else if ((this.formationMonth !== '' &&
          this.formationMonth.length !== 2) ||
          parseInt(this.formationMonth, 10) < 1 || parseInt(this.formationMonth, 10) > 12) {
          alert('월 입력을 다시 확인해주세요.(2자리로 입력해 주세요.)');
        } else if (!this.editagree) {
          alert('관리자의 커뮤니티 수정가능 여부를 선택해 주세요.');
          this.$refs.editagree.focus();
        } else {
          $('#step1').removeClass('active');
          $('#step2').addClass('active');
          $('#decsList1').removeClass('active');
          $('#decsList2').addClass('active');
          $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
        }
      },
      goStep3() {
        if (!this.email) {
          alert('이메일을 입력해 주세요.');
          this.$refs.email.focus();
        } else {
          $('#step2').removeClass('active');
          $('#step3').addClass('active');
          $('#decsList2').removeClass('active');
          $('#decsList3').addClass('active');
          $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
        }
      },
      goStep4() {
        this.isModify2 = false;
        if (this.operators.length === 0) {
          alert('커뮤니티 운영자을 최소 1명 입력해 주세요.');
        } else {
          $('#step3').removeClass('active');
          $('#step4').addClass('active');
          $('#decsList3').removeClass('active');
          $('#decsList4').addClass('active');
          $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
        }
      },
      prevStep(stepNum) {
        $(`#step${parseInt(stepNum, 10) + 1}`).removeClass('active');
        $(`#step${stepNum}`).addClass('active');
        $(`#decsList${parseInt(stepNum, 10) + 1}`).removeClass('active');
        $(`#decsList${stepNum}`).addClass('active');
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
      },
    },
    mounted() {
      this.operators.push({
        name: this.member.name,
        loginid: this.member.loginid,
        phone: this.member.phone,
      });
    },
  };
</script>
<style lang="scss">

  .disabled > a:focus, .disabled > a:hover {
    cursor: not-allowed;
  }

  .nav > li.disabled > a {
    color: #777
  }

  .nav > li.disabled > a:hover, .nav > li.disabled > a:focus {
    color: #777;
    text-decoration: none;
    background-color: transparent;
    cursor: not-allowed
  }
</style>


// WEBPACK FOOTER //
// CommunityTab.vue?5675ca5a